import { translateText } from "./translate-text";
window.addEventListener("load", (e) => {
  document.querySelectorAll("#ult-login-form .forgot-link").forEach((e) => {
    translateText(e, window.loginTranslations);
  });
});
